import { Journey, PageQuestionsItem } from '../../types'

/**
 * Currently this is only for the first page as this is the only use case in wbac
 */
export const getQuestionFromJourney = (parameterName: string, journey: Journey) => {
  const [form] = journey.journeyPages

  return form.pageQuestions.find(({ questionParameterName }) => questionParameterName === parameterName)
}

export default function (pageQuestions: PageQuestionsItem[], question?: PageQuestionsItem) {
  if (!question || !question.dependentQuestionParameterId) {
    return []
  }

  const dependants = (names: string[] = [], dependentQuestionParameterId: number): any => {
    for (const q of pageQuestions) {
      if (q.questionParameterId === dependentQuestionParameterId) {
        names.push(q.questionParameterName)
        if (q.dependentQuestionParameterId) {
          return dependants(names, q.dependentQuestionParameterId!)
        }

        return names
      }
    }

    return names
  }

  return dependants([], question.dependentQuestionParameterId!)
}
